import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faHeartBroken } from '@fortawesome/free-solid-svg-icons';
import { ButtonModule } from 'primeng/button';


@Component({
  selector: 'app-no-active-homepage',
  imports: [FontAwesomeModule, ButtonModule, RouterModule],
  templateUrl: './no-active-homepage.component.html',
  styleUrl: './no-active-homepage.component.scss'
})
export class NoActiveHomepageComponent {
  faHeartBroken = faHeartBroken;

}
